import { RestrictionModel } from './restriction.mode';
import { DependentModel } from './dependent.model';
import { AutomaticRechargeModel } from './automaticRecharge.model';
import { CompanyModel } from './company.model';
import { SignaturesModel } from './signatures.model';
import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { CurrencyModel } from '../components/input/rules/implementations/currency.model';

export class ConfigurationModel {
  dailyLimit: number;
  dailyConsumptionEstimate: number;
  restrictions: RestrictionModel[];
  dependent: DependentModel;
  recharge: AutomaticRechargeModel;
  company: CompanyModel;
  signatures: SignaturesModel[];

  dailyLimitToShow: string;
  dailyLimitInputModel = new InputModel(false, false, 'tel', 'R$ 0,00', [new RequiredModel()], new CurrencyModel());

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/configuration.model.ts